<template>
    <modal @close="cancelEdit" dialog="modal-lg" class="eventEdit-modal view dark-top">
        <div slot="title" class="fs-large mt-4 mb-3 text-center">
          {{getBulkSelectedIds.length}} Booking{{(getBulkSelectedIds.length > 1)? 's':null}} selected
        </div>

        <div slot="body">
            <div class="bulkMainHolder d-flex w-100 h-100">
              <div class="col-md-4 bg-lighter darker font-weight-600 px-0 ">
                <ul class="h-100 bg-lightest">
                  <li class="py-3 pl-3 pointer" :class="{'bg-lighter':button.selected}" @click="selectLeftButton(button)" v-for="button in leftButtons" v-if="button.enabled">{{button.label}}</li>
                </ul>
              </div>
              <div class="col-md-8">
                <div :is="activeArea" :bulkObject="bulkObject" @closeModal="cancelEdit"></div>
              </div>
            </div>
        </div>

        <div slot="footer">
            <footerButtons :activeArea="activeArea" v-on:submitBulk="submitBulk" v-on:cancelEdit="cancelEdit" :bulkObject="bulkObject"></footerButtons>
        </div>
    </modal>
</template>

<script>
    import { eventHub } from '../../main'
    import { mapGetters, mapActions } from 'vuex'
    import Modal from './Modal'

    import areaNotes from './ReservationsBulkActions/areaNotes'
    import areaTickets from './ReservationsBulkActions/areaTickets'
    import areaCheckin from './ReservationsBulkActions/areaCheckin'
    import areaInvoice from './ReservationsBulkActions/areaInvoice'

    import footerButtons from './ReservationsBulkActions/footerButtons'

    export default {
        data() {
            return {
                unModifiedEvent: null,
                activeArea: 'areaInvoice',
                leftButtons: [
                    {
                        label:'Add Note',
                        selected: false,
                        area: 'areaNotes',
                        enabled: false,
                    },
                    {
                        label:'Ticket',
                        selected: false,
                        area: 'areaTickets',
                        enabled: false,
                    },
                    {
                        label:'Check-in',
                        selected: false,
                        area: 'areaCheckin',
                        enabled: false,
                    },
                    {
                        label:'Invoice',
                        selected: true,
                        area: 'areaInvoice',
                        enabled: true,
                    }
                ],
                bulkObject: {
                    deliverNotification: true,
                    note: null
                },
            }
        },
        props: {
            show: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            ...mapGetters([
                'account',
                'getBulkSelectedIds'
            ]),
        },
        methods: {
            ...mapActions([
                'closeModal'
            ]),
            selectLeftButton(button) {
                for (let leftButton of this.leftButtons) {
                    leftButton.selected = false;
                }
                button.selected = true;
                this.activeArea = button.area;
            },
            setActiveArea(areaName) {
                for (let leftButton of this.leftButtons) {
                    if(leftButton.area == areaName){
                        leftButton.selected = true;
                        this.activeArea = areaName;
                    } else {
                        leftButton.selected = false;
                    }
                }
            },
            cancelEdit() {
                this.closeModal();
            },
            sendNote() {
                return axios.post('/api/booking/BulkAddCustomerNote', {
                    supplierId: this.account.supplierId,
                    bookingIds: this.getBulkSelectedIds,
                    note: this.bulkObject.note,
                    sendNotification: this.bulkObject.deliverNotification,
                }).then(response => {
                    this.$toasted.info(response.data);
                })
            },
            submitBulk() {
                if(this.bulkObject.note){
                    this.sendNote().then(response => {
                        this.closeModal();
                    })
                }
            }
        },
        components: {
            Modal,
            footerButtons,
            areaNotes,
            areaCheckin,
            areaTickets,
            areaInvoice
        }
    }
</script>

<style lang="scss">
    // Not scopped so it affects modal-body, parent eventEdit-modal used instead of scooped
    .eventEdit-modal {
        .bulkMainHolder {
            min-height: 250px;
        }
    }
</style>



// WEBPACK FOOTER //
// ReservationsBulkActions.vue?843db9b2